module.exports = __webpack_public_path__ + "img/credito_cerrado.8bd6d13d.png";